// extracted by mini-css-extract-plugin
export default {"containerMain":"About_containerMain__QSGeG","containerBanner":"About_containerBanner__EoRm5","containerCollapse":"About_containerCollapse__izaFL"};